import React from "react";
import { IonIcon } from "@ionic/react";
import {
  calendarClearOutline,
  informationCircleOutline,
  megaphoneOutline,
  sparklesOutline,
} from "ionicons/icons";
import "./CityUpdatesContent.css";

interface CityUpdatesContentProps {
  compactCopy?: boolean;
}

const CityUpdatesContent: React.FC<CityUpdatesContentProps> = ({ compactCopy = false }) => {
  return (
    <div className="chat-updates-shell">
      <div className="chat-updates-hero">
        <div className="chat-updates-badge">
          <IonIcon icon={sparklesOutline} />
          <span>Coming soon</span>
        </div>

        <span className="chat-updates-kicker">City pulse</span>

        <h2 className="chat-updates-title">{"What's happening in Bacolod"}</h2>
        <p className="chat-updates-copy">
          {compactCopy
            ? "This space will soon show city happenings, featured spots, and helpful local updates."
            : "We're preparing a dedicated space for city happenings, local highlights, and timely updates right beside your AI chat."}
        </p>
      </div>

      <div className="chat-updates-section-head">
        <span>{"Soon you'll see"}</span>
      </div>

      <div className="chat-updates-list">
        <div className="chat-updates-item">
          <span className="chat-updates-item-icon">
            <IonIcon icon={calendarClearOutline} />
          </span>
          <div className="chat-updates-item-copy">
            <strong>Events and festivals</strong>
            <span>
              {compactCopy
                ? "See what&apos;s happening around the city in one glance."
                : "Masskara schedules, pop-ups, and community gatherings."}
            </span>
          </div>
        </div>
        <div className="chat-updates-item">
          <span className="chat-updates-item-icon">
            <IonIcon icon={megaphoneOutline} />
          </span>
          <div className="chat-updates-item-copy">
            <strong>City buzz</strong>
            <span>
              {compactCopy
                ? "Catch new openings, food discoveries, and city buzz."
                : "Openings, food spots, nightlife picks, and local promos."}
            </span>
          </div>
        </div>
        <div className="chat-updates-item">
          <span className="chat-updates-item-icon">
            <IonIcon icon={informationCircleOutline} />
          </span>
          <div className="chat-updates-item-copy">
            <strong>Useful notices</strong>
            <span>
              {compactCopy
                ? "Practical info for getting around Bacolod more smoothly."
                : "Travel advisories, route changes, and helpful local info."}
            </span>
          </div>
        </div>
      </div>

      <div className="chat-updates-footnote">
        <strong>Designed for city rhythm.</strong>
        <span>Verified notices, standout local picks, and practical updates in one calm side rail.</span>
      </div>
    </div>
  );
};

export default CityUpdatesContent;
